import React, { useMemo, useState } from 'react';
import UsefulContext from '@contexts/UsefulContext';

interface ILibraryProvider {
  children: React.ReactNode;
}

const UsefulProvider: React.FC<ILibraryProvider> = (props) => {
  const [deleteCategoryId, setDeleteCategoryId] = useState<string>('');
  const [editCategoryId, setEditCategoryId] = useState<string>('');
  const [isDocument, setIsDocument] = useState<boolean>(false);
  const [currentFileUuid, setCurrentFileUuid] = useState<string>('');
  const [infoCategoryId, setInfoCategoryId] = useState<string>('');

  const contextValue = useMemo(
    () => ({
      deleteCategoryId,
      editCategoryId,
      infoCategoryId,
      isDocument,
      currentFileUuid,
      setDeleteCategoryId,
      setEditCategoryId,
      setInfoCategoryId,
      setIsDocument,
      setCurrentFileUuid
    }),
    [
      deleteCategoryId,
      editCategoryId,
      infoCategoryId,
      isDocument,
      currentFileUuid,
      setDeleteCategoryId,
      setEditCategoryId,
      setInfoCategoryId,
      setIsDocument,
      setCurrentFileUuid
    ]
  );

  return (
    <UsefulContext.Provider value={contextValue}>
      {props.children}
    </UsefulContext.Provider>
  );
};

export default UsefulProvider;
